import { ConfigService } from './../common/services/config.service';
import { HttpInterceptor } from '../common/services/httpInterceptor.service';
import { Injectable } from '@angular/core';
import { CookieHandlerService } from './../common/services/cookieHandler.service';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SessionHandlerService } from '../common/services/sessionHandler.service';
import { CommonConstants } from '../common/utilities/commonConstants';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {
  constructor(
    private _httpInterceptor: HttpInterceptor,
    private _cookieHandler: CookieHandlerService,
    private _http: HttpClient,
    private _sessionHandlerService: SessionHandlerService
  ) { }
  public GetPaymentDetails(applicationId: string, data?: any): Observable<ActivitiModel.MTResponse<any>> {
    const url = ConfigService.getInstance().getConfigObject().APIURL.getPaymentDetails;
    return this._httpInterceptor.Post(url, data, true);
  }
  public checkEmiCardEligibilty(
    requestData: any
  ): Observable<ActivitiModel.MTResponse<any>> {
    const url = ConfigService.getInstance().getConfigObject().APIURL.emicardeligibiltyservice;
    return this._httpInterceptor.Post(url, requestData);
  }
  // mock jsons
  public GetJSON(url: any) {
    return this._http.get(url);
  }

  public PostCallEMIPayment(data: any, action) {
    let url;
    if (action === 'retryEmi') {
      action = 'payEmi';
      url = ConfigService.getInstance().getConfigObject().APIURL.retryPayment;
    } else {
      url = ConfigService.getInstance().getConfigObject().APIURL.personalDetailsCall;
      url = url.replace('{applicationId}', data.payload.applicationId);
      url = url.replace('{quoteId}', data.payload.quoteId);
      url = url.replace('{personCode}', data.personCode);
    }
    return this._httpInterceptor.Post(url, { action: action, payload: data.payload });
  }

  public PostCallRazorPayment(requestData: any, razorPayType, personQuoteId, retryAction): Observable<ActivitiModel.MTResponse<any>> {
    let url;
    let action;
    if (razorPayType === 'postprocessingPayment') {
      action = 'payRazor'; // 'paymentSuccess';
    } else {
      // If razor pay popup closed
      action = 'payRazor'; // 'paymentFailed';
    }
    if (retryAction === 'retryRazorPay') {
      url = ConfigService.getInstance().getConfigObject().APIURL.retryPayment;
    } else {
      url = ConfigService.getInstance().getConfigObject().APIURL.personalDetailsCall;
    }
    url = url.replace('{applicationId}', requestData.applicationId);
    url = url.replace('{quoteId}', personQuoteId.quoteId);
    url = url.replace('{personCode}', personQuoteId.personCode);
    return this._httpInterceptor.Post(url, { action: action, payload: requestData });
  }
  public PostCallBack(action: string): Observable<ActivitiModel.MTResponse<any>> {
    const url = ConfigService.getInstance().getConfigObject().APIURL.retryPayment;
    return this._httpInterceptor.Post(url, { action: action, payload: null });
  }

  public paymentStatusSuccessCall(requestData: any, retryAction?: string) {
    let url;
    if (retryAction === 'retryPayment') {
      url = ConfigService.getInstance().getConfigObject().APIURL.retryPayment;
    } else {
      url = ConfigService.getInstance().getConfigObject().APIURL.personalDetailsCall;
    }
    url = url.replace('{applicationId}', requestData.applicationId);
    url = url.replace('{quoteId}', requestData.quoteId);
    url = url.replace('{personCode}', requestData.personCode);
    return this._httpInterceptor.Post(url, { action: 'paymentSuccess', payload: null });
  }
  public saveCustomerJourneyData(savePayload: any): Observable<ActivitiModel.MTResponse<any>> {
    let url = (ConfigService.getInstance().getConfigObject().APIURL.saveCustomerJourneyData);
    return this._httpInterceptor.Post(url, savePayload);
  }
  public postPaymentStatus(savePayload): Observable<any> {
    let url = ConfigService.getInstance().getConfigObject().APIURL.postPaymentStatus;
    return this._httpInterceptor.Post(url, savePayload);
  }
  public getPaymentStatus(quoteId: string, applicationId: any): Observable<any> {
    let url = ConfigService.getInstance().getConfigObject().APIURL.getPaymentStatus;
    url = url.replace('{applicationId}', applicationId ? applicationId : 0);
    url = url.replace('{quoteId}', quoteId ? quoteId : 0);
    return this._httpInterceptor.Get(url, true);
  }

  public getcallbackPayment(data: any, _merchantCode: any): Observable<any> {
    const headerObj: HttpHeaders = new HttpHeaders({
      "Content-Type": "application/json;",
      merchantCode: _merchantCode,
      cmptcorrid: this.constantCall() + "|" + this.constantCall(),
      'x-audit-loc-latitude': this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.latitude) ? this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.latitude) : '',
      'x-audit-loc-longitude': this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.longitude) ? this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.longitude) : '',
    });
    const options = { headers: headerObj };

    return this._http.post(environment.paymentFirstCall + "/v1/sessions", data, options);
  }
  constantCall() {
    if (void 0 !== window.crypto && void 0 !== window.crypto.getRandomValues) {
      const t = new Uint16Array(8);
      return window.crypto.getRandomValues(t), this.c(t[0]) + this.c(t[1]) + " " + this.c(t[2]) + " " + this.c(t[3]) + " " + this.c(t[4]) + " " + this.c(t[5]) + this.c(t[6]) + this.c(t[7])
    }
    return this.i() + this.i() + " " + this.i() + " " + this.i() + " " + this.i() + " " + this.i() + this.i() + this.i()
  }
  i() {
    return Math.floor(65536 * (1 + Math.random())).toString(16).substring(1)
  }
  c(t) {
    let e = t.toString(16);
    for (; e.length < 4;) e = "0" + e;
    return e
  }

  getBanners() {
    let url = environment.serviceBaseUrls.AEMBANNERSURL;
    return this._httpInterceptor.GetAem(url);
  }

}
